module.exports = __webpack_public_path__ + "media/src/images/icons/gray-chevron-back-7592bb96760a20eceb517190aaa77f84.svg";